var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value)?_c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.clicked}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }